import Rodape from "Components/Rodape";
import Topo from "Components/Topo";
//import jsonData from '../../json/cadastro.json';
import { useEffect, useState, React, useRef, useCallback  } from "react";
import Webcam from "react-webcam";
import Helper from "Helper";
import Campos from "Components/Campos";
import Camera from "Components/Camera";
import swal from "sweetalert";
import { API_BASE } from "API";

function AbreCamera(){
  const wrapper = document.createElement('div');
  wrapper.innerHTML = <Camera />;
  swal({
    title: "Faça a captura da foto",
    content: wrapper,
    className: "alert_title", 
    icon: "error"
  });
}

function preencheLink(){
  sessionStorage.removeItem("foto");
  let url_arquivo = sessionStorage.getItem("url_arquivo");
  let nomeImagem = sessionStorage.getItem("nomeImagem");
  if(document.getElementById("img_foto") && url_arquivo !=""  && nomeImagem !=""){
      document.getElementById("img_foto").setAttribute("href",url_arquivo);
      document.getElementById("img_foto").setAttribute("data-arquivo",nomeImagem);
      sessionStorage.setItem("foto",nomeImagem);
      document.getElementById("img_foto").classList.remove("Llink_d");
      document.getElementById("img_foto").classList.add("Llink_a");
  }
  return "";
}

function Cadastro(){
const url = API_BASE+"getCadastro.php?cpf="+(sessionStorage.getItem("cpf")?sessionStorage.getItem("cpf"):'')+"&email="+(sessionStorage.getItem("email")?sessionStorage.getItem("email"):'')+"&access_token="+sessionStorage.getItem("token")+"&id_user="+sessionStorage.getItem('nome_usser')+"&cod_usser="+sessionStorage.getItem('cod_usser')+"&cde="+sessionStorage.getItem('cod_empresa')+"&lng="+sessionStorage.getItem('lng')+"&cod_categoria="+(sessionStorage.getItem("cod_categoria")?sessionStorage.getItem("cod_categoria"):'');
const [data, setData] = useState(null);
const [processatipos, setProcessedData] = useState([]);
const [processahistorio, setProcesseHistorico] = useState([]);
const [selectedColor, setSelectedColor] = useState("");
const [selectedValue, setSelectedValue] = useState("");
const [imgbase64, setImgbase64] = useState("");

sessionStorage.setItem('modificado',false);
let url_arquivo ;
let nomeImagem;


if(Helper.ValidaSessao('') == false || (undefined == sessionStorage.getItem('cpf') || null == sessionStorage.getItem('cpf') || "" == sessionStorage.getItem('cpf')) && (undefined == sessionStorage.getItem('email') || null == sessionStorage.getItem('email') || "" == sessionStorage.getItem('email')) && (undefined == sessionStorage.getItem('cod_empresa') || null == sessionStorage.getItem('cod_empresa') || "" == sessionStorage.getItem('cod_empresa'))){
  window.location.href="/";
}

  useEffect(() => {
    // Função para buscar os dados do JSON
    const fetchData = async () => {
      try {
   

        const response = await fetch(url);
        const text = await response.text(); // Obtenha a resposta como texto
        // Remove o BOM se presente
        const cleanText = text.replace(/^\uFEFF/, '');
        const jsonData = JSON.parse(cleanText);
        const fields = jsonData;
        //console.log('fields:',fields);
        const dados = jsonData;

        if(dados.status.duplicidade){
          swal(dados.status.msg,"","error");
          window.location.href="/";
        }
      

        let tipos = [];
        let historico_dados = dados.historico;
        let foto_a = dados.foto;
        //console.log('f:',foto_a[0].imgbase64);
        if(undefined != foto_a && null != foto_a && undefined != foto_a[0].imgbase64 && null != foto_a[0].imgbase64 && "" != foto_a[0].imgbase64){
        
           setImgbase64(foto_a[0].imgbase64);
        
        }
       
        if(undefined != foto_a && null != foto_a && undefined != foto_a[0].url_existente && null != foto_a[0].url_existente){
          url_arquivo = foto_a[0].url_existente;
          nomeImagem = url_arquivo.split('/').pop();
          sessionStorage.setItem("url_arquivo",url_arquivo);
          sessionStorage.setItem("nomeImagem",nomeImagem);
          setTimeout(() => preencheLink(), 500);
        }
        else{
          sessionStorage.setItem("url_arquivo",'');
          sessionStorage.setItem("nomeImagem",'');
        }

        sessionStorage.setItem("cod_empresa_pj",(dados.status.cod_empresa_pj?dados.status.cod_empresa_pj:''));
        sessionStorage.setItem("cod_empresa",(dados.status.cod_empresa_pf?dados.status.cod_empresa_pf:''));

        dados.categoria.map(item => {(
          
        tipos.push(<option value={item.cod_status_preco} selected={((item.escolhido == 'S' && item.cod_status_preco != sessionStorage.getItem("cod_categoria")) || (item.cod_status_preco == sessionStorage.getItem("cod_categoria")))  ? true:false}  title={item.nome}>{item.nome}</option>)    
        )});
        setProcessedData(tipos);
        setData(jsonData);
        setProcesseHistorico(historico_dados);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
      }
    };

    fetchData();

   

  }, []);

  useEffect(() => {
        const select = document.getElementById("tipo_credencial");
        if (!select) return;

        const opt = select.selectedOptions[0];
        /*if (opt) {
            const cor = opt.getAttribute("data-cor");
            setSelectedColor(cor || "");
        }*/
    }, [processatipos]);

  useEffect(() => {
        if(processatipos.length === 1){
            const selectCategoria = document.getElementById("categoria");
            if(selectCategoria && selectCategoria.value != "" && selectCategoria.value != sessionStorage.getItem("cod_categoria")){
                Helper.CarrecaCampos(selectCategoria.value);
            }
        }
    }, [processatipos]);

  if("dev" ==  sessionStorage.getItem('md') || "DEV" ==  sessionStorage.getItem('md')){
      console.log('Chamada GetCadastro:',url);
      console.log('data:',data);
  }
  
  if( data && data.cadastro && data.cadastro[0] && data.cadastro[0].idioma != sessionStorage.getItem("lng")){
    // Ajuste para atualizar o idioma e trazer as categorias corretas
    console.log('Trocando:',sessionStorage.getItem("lng"),data.cadastro[0].idioma);
    sessionStorage.setItem("lng",data.cadastro[0].idioma);
    window.location.href = '/Cadastro'
    return '';
  }

    return (
        data ? (
          (data.cadastro.length > 0 && undefined != data.cadastro[0].cod_inscricao && null != data.cadastro[0].cod_inscricao && data.cadastro[0].cod_inscricao !="" ? sessionStorage.setItem('cod_inscricao',data.cadastro[0].cod_inscricao):''),
        <>
  
        <Topo texto="Cadastro" cor_fundo="fundoCadastro" cor_texto="text-white"></Topo>
        <div className="flex">
        <div className="w-1/3 p-4 remove_celular"></div>
        <form className="max-w-4xl mx-auto p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <div key="tpcred" className={`flex flex-col divs`} >

                <span className="font-medium mb-2">Categoria</span>
                
                

                    <select 
                    className="w-full text-blue-500 font-bold py-2 px-4 rounded border text-center"
                    name="categoria" 
                    id="categoria" 
                    data_obrigatorio="S" 
                    data-validacao = ""
                    data-tipo = "categoria"
                    data-campo = "categoria"
                    title="Categoria"
                    data-cod_campo="categoria" 
                    onChange={(e) => {
                     Helper.CarrecaCampos(e.target.value);
                                    }}
                    >
                    {(processatipos.length >1 ? <option value="">Selecione</option>:'')}
                    {processatipos}
                    </select>
              </div>


              <div key="tpcred" className={`flex flex-col divs`} >

                
              </div>

              {data.campos_empresa.length>0 ?
                  <h1 className="col-span-2 font-bold">Dados da Empresa</h1>
              :''}

               {data.campos_empresa.map((item) => ( 
                <div key={item.cod_campo} data-c={item.cod_campo} className={`flex flex-col divs `} >
                <Campos item={item}/>
                </div>
                ))}

              

             {data.campos_participante.length>0 ?
                  <h1 className="col-span-2 font-bold">Dados do Participante</h1>
              :''}

            {data.campos_participante.map((item) => ( 
                <div key={item.cod_campo} data-c={item.cod_campo} className={`flex flex-col divs `} >
                <Campos item={item}/>
                </div>
                ))}



                
            </div>
             
         </form>

        
          

            <div className="w-1/3 p-4 flex flex-col items-center cad_celular">
                        <div className="w-full py-2 px-4 rounded mb-3 text-center">
                            
                                <table className="table-auto w-full left_celular">
                                    <tbody>
                                        <tr className="fundoCadastro">
                                            <td className="border px-4 py-2 text-white font-bold"><b>CADASTRO</b></td>
                                        </tr>
                                        <tr>
                                            <td className="border px-4 py-2 text-xl">
                                                <input type="hidden" name="cod_inscricao" id="cod_inscricao" value={(data.cadastro.length > 0 && undefined != data.cadastro[0].cod_inscricao && null != data.cadastro[0].cod_inscricao && data.cadastro[0].cod_inscricao !="" ? data.cadastro[0].cod_inscricao:'')} />
                                                <input type="hidden" name="cod_empresa" id="cod_empresa" value={(data.cadastro.length > 0 && undefined != data.cadastro[0].cod_empresa && null != data.cadastro[0].cod_empresa && data.cadastro[0].cod_empresa !="" ? data.cadastro[0].cod_empresa:'')} />
                                            <div id="tx_cod_inscricao">{(data.cadastro.length > 0 && undefined != data.cadastro[0].cod_empresa && null != data.cadastro[0].cod_empresa && data.cadastro[0].cod_empresa !="" ? data.cadastro[0].cod_empresa:'')}</div>
                                            </td>
                                        </tr>
                                    
                                    </tbody>
                                </table>

                        </div>
                <Camera />
                {( imgbase64 ? <img src={imgbase64} className="w-1/2 h-auto mb-4" />:'')}
                <a href="#" id="img_foto" target="_blank" data-arquivo="" className="Llink_d">Link da Imagem</a>
                <button className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-3" onClick={(ev) => {Helper.AbreModal(processahistorio)}}>Histórico</button>

                 {(parseInt(data.campos_empresa.length) >  0 || parseInt(data.campos_participante.length) > 0 ?
                <>
                <br /><br />
                <div id="loading"></div><button className="w-full bg-black text-white font-bold py-2 px-4 rounded mb-3" id="avancar_cadastro" onClick={()=>{Helper.validaInscricao(3)}}>Avançar</button>
                </>
                  :'')}
            </div>
            <div className="w-1/3 p-4 remove_celular"></div>
        </div>  
         {(parseInt(data.campos_empresa.length) >  0 || parseInt(data.campos_participante.length) > 0 ?
            <><div className="w-full  text-center"><button className="w-full bg-black text-white font-bold py-2 px-4 rounded mb-3" id="avancar_cadastro2" onClick={()=>{Helper.validaInscricao(3)}}>Avançar</button></div></>
         :'')} 
        <Rodape passo="2"/>
       
        </>
        
          ) : (
            <p>Carregando...</p>
          ) 
         
        )

     

    
     
}

export default Cadastro;